module.exports = __webpack_public_path__ + "static/media/bg.5fd0687d.svg";